import React, { useState } from 'react';
import { Button } from 'react-admin';
import SyncIcon from '@material-ui/icons/Sync';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import API from '@aws-amplify/api';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const apiName = 'SyncApi';
const path = '/sync/reconnectBrandsAndShops';
const myInit = {
  body: {},
  headers: {},
};

const ReconnectButton = () => {
  const [openInfo, setOpenInfo] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  function handleClick() {
    setOpenInfo(true);
    API.post(apiName, path, myInit)
      .then((response) => {
        // console.log(response);
        setOpenSuccess(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleCloseInfo() {
    setOpenInfo(false);
  }

  function handleCloseSuccess() {
    setOpenSuccess(false);
  }

  return (
    <>
      <Button label="Reconnect" onClick={handleClick}>
        <SyncIcon />
      </Button>
      <Snackbar
        open={openInfo}
        autoHideDuration={3000}
        onClose={handleCloseInfo}
      >
        <Alert onClose={handleCloseInfo} severity="info">
          Started reconnecting to shops!
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccess}
        autoHideDuration={3000}
        onClose={handleCloseSuccess}
      >
        <Alert onClose={handleCloseSuccess} severity="success">
          Finished reconnecting to shops!
        </Alert>
      </Snackbar>
    </>
  );
};

export default ReconnectButton;
